<script>
    import Button from "./Button.svelte";
    import windows from "../../stores/windows.js";
    import isMobile from "../../helpers/mobile.js";
    import profile from "../../stores/profile.js";

    export let window;

    const padding = 20.0;

    let isMouseDown = false;
    let initialMouseLocation;
    let initialWindowLocation;

    let innerWidth = 0;
    let innerHeight = 0;

    $: title = window.kind === "vehicle" ? $profile.displayName : window.title;

    function didClickCloseButton() {
        windows.close(window.id);
    }

    function pointerLocation(e) {
        if (e.touches && e.touches.length > 0) {
            const [touch] = e.touches;
            return { x: touch.pageX, y: touch.pageY };
        }

        return { x: e.clientX, y: e.clientY };
    }

    function didMouseDown(e) {
        if (isMobile) {
            return;
        }

        isMouseDown = true;
        initialMouseLocation = pointerLocation(e);
        initialWindowLocation = { ...window };
    }

    function didMouseMove(e) {
        if (!isMouseDown) {
            return;
        }

        const location = pointerLocation(e);

        const offset = {
            x: location.x - initialMouseLocation.x,
            y: location.y - initialMouseLocation.y
        };

        windows.move(
            window.id,
            Math.min(
                Math.max(initialWindowLocation.x + offset.x, padding),
                innerWidth - window.width - padding
            ),
            Math.min(
                Math.max(initialWindowLocation.y + offset.y, padding),
                innerHeight - window.height - padding
            )
        );
    }

    function didMouseUp() {
        isMouseDown = false;
    }
</script>

<svelte:window
    on:mousemove={didMouseMove}
    on:touchmove={didMouseMove}
    on:mouseup={didMouseUp}
    on:touchend={didMouseUp}
    bind:innerWidth
    bind:innerHeight
/>

<div
    class="title"
    class:focused={window.isFocused}
    on:mousedown={didMouseDown}
    on:touchstart={didMouseDown}
>
    <h1>{window.props.title || title}</h1>
    {#if !window.isModal}
        <button on:click={didClickCloseButton} data-close="true">&times;</button
        >
    {/if}
</div>

<style>
    .title {
        position: relative;
        cursor: move;
        border-bottom: var(--chrome-hsl) var(--chrome-depth) solid;
        background: var(--window-title-background-inactive);
        width: 100%;
        height: var(--window-title-height);
    }

    .title.focused {
        background: var(--window-title-background);
    }

    .title > * {
        position: absolute;
    }

    h1 {
        position: absolute;
        top: 50%;
        transform: translateY(calc(-50% - 1px));
        margin: 0;
        width: 100%;
        color: var(--chrome-hsl);
        text-align: center;
    }

    .focused h1 {
        color: white;
    }

    button {
        top: 50%;
        right: 4px;
        transform: translateY(calc(-50% - 1.5px));
        appearance: none;
        margin: 0;
        border: none;
        background: none;
        padding: 0;
        color: var(--chrome-hsl);
        font-weight: bold;
        font-size: 15px;
    }

    .focused button {
        color: white;
    }
</style>
